module.exports = __webpack_public_path__ + "static/media/optimize.5dea36a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Configuration/Render/Helper/svg/optimize.svg
// module id = 2207
// module chunks = 0